import React from 'react'

export default function Tiktok(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={15}
            height={15}
            fill="none"
            {...props}
        >
            <path
                fill="#fff"
                d="M10.67 0H8.142v10.217c0 1.218-.972 2.218-2.182 2.218s-2.182-1-2.182-2.218c0-1.195.95-2.174 2.117-2.217V5.435c-2.57.043-4.645 2.152-4.645 4.782C1.25 12.87 3.367 15 5.982 15c2.614 0 4.731-2.152 4.731-4.783V4.978a5.854 5.854 0 0 0 3.35 1.13V3.544C12.16 3.478 10.67 1.913 10.67 0Z"
            />
        </svg>
    )
}
